window.onload = function() {
  const galleryElement = document.querySelector('.gallery > .swiper');
  if (galleryElement) {
    const galleryImages = new Swiper(galleryElement, {
      slidesPerView: 1,
      spaceBetween: 15,
      loop: false,
      centeredSlides: true,
      centeredSlidesBounds: true,
      pagination: {
        el: '.gallery__slider-pagination',
        clickable: true
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      breakpoints: {
        993: {
          slidesPerView: 4
        },
        768: {
          slidesPerView: 3,
          freeMode: false
        },
        320: {
          freeMode: true,
          loop: false,
        }
      }
    });
  } else {
    console.warn('Elemento .gallery > .swiper não encontrado.');
  }

  const collectionsElement = document.querySelector('.collections-gallery .swiper');
  if (collectionsElement) {
    const galleryCollections = new Swiper(collectionsElement, {
      slidesPerView: 2,
      spaceBetween: 10,
      loop: true,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: '.featured-products__slider-pagination',
        clickable: true
      },
      breakpoints: {
        993: {
          slidesPerView: 4
        },
        768: {
          slidesPerView: 3,
          freeMode: false
        },
        320: {
          slidesPerView: 2,
          freeMode: true,
          loop: false,
        }
      }
    });
  } else {
    console.warn('Elemento .collections-gallery .swiper não encontrado.');
  }

  // ========================================
  // CARROSSEL COM SWIPE PARA MOBILE
  // ========================================
  
  // Função para inicializar o carrossel mobile com uma imagem por vez
  function initMobileCarousel() {
    // Só executar no mobile
    if (window.innerWidth > 767) return;
    
    const productMedia = document.querySelector('.product-media--layout-custom_4_cards');
    if (!productMedia) return;
    
    const gridImages = productMedia.querySelector('.product-media__grid-images');
    const gridItems = productMedia.querySelectorAll('.product-media__grid-item');
    
    if (!gridImages || gridItems.length === 0) return;
    
    // Configurar container do carrossel
    gridImages.style.cssText = `
      display: flex !important;
      flex-direction: row !important;
      overflow-x: auto !important;
      overflow-y: hidden !important;
      scroll-snap-type: x mandatory !important;
      scroll-behavior: smooth !important;
      height: 414px !important;
      min-height: 414px !important;
      max-height: 414px !important;
      width: 100% !important;
      max-width: 100% !important;
      -webkit-overflow-scrolling: touch !important;
      scrollbar-width: none !important;
      -ms-overflow-style: none !important;
    `;
    
    // Configurar cada item do carrossel
    gridItems.forEach((item, index) => {
      item.style.cssText = `
        display: block !important;
        flex: 0 0 100% !important;
        width: 100% !important;
        height: 414px !important;
        min-height: 414px !important;
        max-height: 414px !important;
        scroll-snap-align: start !important;
      `;
      
      // Configurar imagem dentro do item
      const img = item.querySelector('img');
      if (img) {
        img.style.cssText = `
          width: 331px !important;
          height: 414px !important;
          min-width: 331px !important;
          max-width: 331px !important;
          min-height: 414px !important;
          max-height: 414px !important;
          object-fit: contain !important;
          object-position: center !important;
          display: block !important;
        `;
      }
    });
    
    // Esconder scrollbar
    gridImages.style.setProperty('scrollbar-width', 'none', 'important');
    gridImages.style.setProperty('-ms-overflow-style', 'none', 'important');
    
    // Adicionar CSS para esconder scrollbar no WebKit
    const style = document.createElement('style');
    style.textContent = `
      .product-media--layout-custom_4_cards .product-media__grid-images::-webkit-scrollbar {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
    
    // Sistema de navegação por índice
    let currentIndex = 0;
    const totalItems = gridItems.length;
    
    // Função para ir para um índice específico
    function goToSlide(index) {
      if (index < 0 || index >= totalItems) return;
      
      currentIndex = index;
      const slideWidth = gridImages.offsetWidth;
      const scrollPosition = index * slideWidth;
      
      gridImages.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });
      
      updateIndicators();
    }
    
    // Touch events para swipe
    let startX = 0;
    let startY = 0;
    let isScrolling = false;
    
    gridImages.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isScrolling = false;
    }, { passive: false });
    
    gridImages.addEventListener('touchmove', (e) => {
      const diffX = Math.abs(e.touches[0].clientX - startX);
      const diffY = Math.abs(e.touches[0].clientY - startY);
      
      // Se movimento horizontal for maior que vertical, é swipe
      if (diffX > diffY && diffX > 15) {
        isScrolling = true;
        e.preventDefault();
      }
    }, { passive: false });
    
    gridImages.addEventListener('touchend', (e) => {
      if (!isScrolling) return;
      
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      
      if (Math.abs(diff) > 50) {
        if (diff > 0 && currentIndex < totalItems - 1) {
          // Swipe para esquerda - próximo slide
          goToSlide(currentIndex + 1);
        } else if (diff < 0 && currentIndex > 0) {
          // Swipe para direita - slide anterior
          goToSlide(currentIndex - 1);
        }
      }
      
      isScrolling = false;
    });
    
    // Mouse drag para desktop mobile
    let isMouseDown = false;
    let startMouseX = 0;
    let startScrollLeft = 0;
    
    gridImages.addEventListener('mousedown', (e) => {
      isMouseDown = true;
      startMouseX = e.clientX;
      startScrollLeft = gridImages.scrollLeft;
      gridImages.style.cursor = 'grabbing';
      e.preventDefault();
    });
    
    gridImages.addEventListener('mousemove', (e) => {
      if (!isMouseDown) return;
      
      const diff = e.clientX - startMouseX;
      gridImages.scrollLeft = startScrollLeft - diff;
    });
    
    gridImages.addEventListener('mouseup', () => {
      if (!isMouseDown) return;
      
      isMouseDown = false;
      gridImages.style.cursor = 'grab';
      
      // Snap para o slide mais próximo
      const slideWidth = gridImages.offsetWidth;
      const targetIndex = Math.round(gridImages.scrollLeft / slideWidth);
      const safeIndex = Math.max(0, Math.min(targetIndex, totalItems - 1));
      
      goToSlide(safeIndex);
    });
    
    gridImages.addEventListener('mouseleave', () => {
      if (isMouseDown) {
        isMouseDown = false;
        gridImages.style.cursor = 'grab';
        
        // Snap para o slide mais próximo
        const slideWidth = gridImages.offsetWidth;
        const targetIndex = Math.round(gridImages.scrollLeft / slideWidth);
        const safeIndex = Math.max(0, Math.min(targetIndex, totalItems - 1));
        
        goToSlide(safeIndex);
      }
    });
    
    // Cursor inicial
    gridImages.style.cursor = 'grab';
    
    // Posicionar no primeiro slide
    gridImages.scrollLeft = 0;
    currentIndex = 0;
    
    // Adicionar indicadores (apenas se não for benefits)
    if (totalItems > 1 && !productMedia.closest('.benefits-section, .benefits, [class*="benefit"]')) {
      addCarouselIndicators(gridImages, gridItems, currentIndex, goToSlide);
    }
    
    // Função para atualizar indicadores
    function updateIndicators() {
      const indicators = document.querySelectorAll('.carousel-indicator');
      indicators.forEach((ind, index) => {
        ind.style.backgroundColor = index === currentIndex ? '#007bff' : '#ddd';
      });
    }
    
    // Atualizar indicadores quando scroll mudar
    gridImages.addEventListener('scroll', () => {
      const slideWidth = gridImages.offsetWidth;
      const newIndex = Math.round(gridImages.scrollLeft / slideWidth);
      
      if (newIndex !== currentIndex && newIndex >= 0 && newIndex < totalItems) {
        currentIndex = newIndex;
        updateIndicators();
      }
    });
  }
  
  // Função para rolagem automática dos benefits no mobile
  function initBenefitsAutoScroll() {
    // Só executar no mobile
    if (window.innerWidth > 767) return;
    
    const benefitsSections = document.querySelectorAll('.benefits-section, .benefits, [class*="benefit"]');
    
    benefitsSections.forEach(section => {
      const carousel = section.querySelector('.product-media--layout-custom_4_cards');
      if (!carousel) return;
      
      const gridImages = carousel.querySelector('.product-media__grid-images');
      const gridItems = carousel.querySelectorAll('.product-media__grid-item');
      
      if (!gridImages || gridItems.length <= 1) return;
      
      // Configurar rolagem automática
      let currentSlide = 0;
      const totalSlides = gridItems.length;
      const autoScrollInterval = 3000; // 3 segundos por slide
      
      // Função para ir para o próximo slide
      function nextSlide() {
        currentSlide = (currentSlide + 1) % totalSlides;
        const slideWidth = gridImages.offsetWidth;
        const scrollPosition = currentSlide * slideWidth;
        
        gridImages.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });
      }
      
      // Iniciar rolagem automática
      const autoScrollTimer = setInterval(nextSlide, autoScrollInterval);
      
      // Pausar rolagem automática quando o usuário interagir
      let isUserInteracting = false;
      
      // Touch events
      gridImages.addEventListener('touchstart', () => {
        isUserInteracting = true;
        clearInterval(autoScrollTimer);
      });
      
      gridImages.addEventListener('touchend', () => {
        // Retomar rolagem automática após 5 segundos de inatividade
        setTimeout(() => {
          isUserInteracting = false;
          if (!isUserInteracting) {
            const newTimer = setInterval(nextSlide, autoScrollInterval);
            // Armazenar o novo timer para poder limpar depois
            gridImages.dataset.autoScrollTimer = newTimer;
          }
        }, 5000);
      });
      
      // Mouse events
      gridImages.addEventListener('mouseenter', () => {
        isUserInteracting = true;
        clearInterval(autoScrollTimer);
      });
      
      gridImages.addEventListener('mouseleave', () => {
        // Retomar rolagem automática após 3 segundos
        setTimeout(() => {
          isUserInteracting = false;
          if (!isUserInteracting) {
            const newTimer = setInterval(nextSlide, autoScrollInterval);
            gridImages.dataset.autoScrollTimer = newTimer;
          }
        }, 3000);
      });
      
      // Armazenar o timer para poder limpar quando necessário
      gridImages.dataset.autoScrollTimer = autoScrollTimer;
      
      // Limpar timer quando a página for descarregada
      window.addEventListener('beforeunload', () => {
        clearInterval(autoScrollTimer);
      });
    });
  }
  
  // Função para adicionar indicadores visuais do carrossel
  function addCarouselIndicators(container, items, currentIndex, goToSlide) {
    // Remover indicadores existentes
    const existingIndicators = container.parentNode.querySelector('.carousel-indicators');
    if (existingIndicators) {
      existingIndicators.remove();
    }
    
    // Criar container de indicadores
    const indicatorsContainer = document.createElement('div');
    indicatorsContainer.className = 'carousel-indicators';
    indicatorsContainer.style.cssText = `
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      gap: 8px;
      z-index: 10;
    `;
    
    // Criar indicadores
    items.forEach((_, index) => {
      const indicator = document.createElement('div');
      indicator.className = 'carousel-indicator';
      indicator.style.cssText = `
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: ${index === currentIndex ? '#007bff' : '#ddd'};
        cursor: pointer;
        transition: background-color 0.3s ease;
      `;
      
      // Adicionar evento de clique usando a função goToSlide
      indicator.addEventListener('click', () => {
        goToSlide(index);
      });
      
      indicatorsContainer.appendChild(indicator);
    });
    
    // Adicionar ao container pai
    container.parentNode.style.position = 'relative';
    container.parentNode.appendChild(indicatorsContainer);
  }
  
  // Função para garantir que o breadcrumb__container fique acima da imagem
  function fixBreadcrumbPosition() {
    // Só executar no mobile
    if (window.innerWidth > 767) return;
    
    const breadcrumbContainer = document.querySelector('.breadcrumb__container');
    const productMedia = document.querySelector('.product-media--layout-custom_4_cards');
    
    if (breadcrumbContainer && productMedia) {
      // Verificar se o breadcrumb já foi movido
      if (breadcrumbContainer.parentNode === productMedia) {
        return; // Já está na posição correta
      }
      
      // Mover apenas o breadcrumb__container para o início da galeria de produtos
      productMedia.insertAdjacentElement('afterbegin', breadcrumbContainer);
      
      // Garantir que o breadcrumb seja visível
      breadcrumbContainer.style.display = 'block';
      breadcrumbContainer.style.visibility = 'visible';
      breadcrumbContainer.style.opacity = '1';
    }
  }
  
  // Inicializar carrossel e posicionar breadcrumb APENAS no mobile
  if (window.innerWidth <= 767) {
    initMobileCarousel();
    fixBreadcrumbPosition();
  }
  
  // Reinicializar quando a tela for redimensionada
  window.addEventListener('resize', () => {
    if (window.innerWidth <= 767) {
      initMobileCarousel();
      fixBreadcrumbPosition();
    }
  });

  // Função para remover texto "2x de preço" dos cards e página do produto
  function removeInstallmentText() {
    // Remover de cards de produtos
    const productCards = document.querySelectorAll('.product-card, .featured-product, .collection-product');
    productCards.forEach(card => {
      const installmentElements = card.querySelectorAll('[class*="installment"], [class*="payment"], [class*="price"]');
      installmentElements.forEach(element => {
        if (element.textContent.includes('2x de') || element.textContent.includes('2x')) {
          element.style.display = 'none';
        }
      });
    });
    
    // Remover da página do produto
    const productPage = document.querySelector('.template-product, .product-template');
    if (productPage) {
      const installmentElements = productPage.querySelectorAll('[class*="installment"], [class*="payment"], [class*="price"]');
      installmentElements.forEach(element => {
        if (element.textContent.includes('2x de') || element.textContent.includes('2x')) {
          element.style.display = 'none';
        }
      });
    }
    
    // Remover de elementos específicos com texto de parcelamento
    const allElements = document.querySelectorAll('*');
    allElements.forEach(element => {
      if (element.children.length === 0 && element.textContent.includes('2x de')) {
        element.style.display = 'none';
      }
    });
  }
  
  // Executar remoção do texto de parcelamento
  removeInstallmentText();
  
  // Observar mudanças no DOM para remover texto de parcelamento dinamicamente
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Elemento DOM
            if (node.textContent && node.textContent.includes('2x de')) {
              node.style.display = 'none';
            }
            // Verificar elementos filhos
            const installmentElements = node.querySelectorAll ? node.querySelectorAll('*') : [];
            installmentElements.forEach(element => {
              if (element.textContent && element.textContent.includes('2x de')) {
                element.style.display = 'none';
              }
            });
          }
        });
      }
    });
  });
  
  // Iniciar observação
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
};


// Aplicando cupom inserido no minicart
var manageCoupon = {
	getCookie: function(name) {
	    var cookies = document.cookie;
	    var parts = cookies.split(name + "=");
	    var cookieValue = '';
	    if (parts.length == 2) {
	        cookieValue = parts.pop().split(";").shift();
	    }
	    
	    return cookieValue;
	},
	
	setCookie: function(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + (exdays*24*60*60*1000));
		let expires = "expires="+ d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	},

	applyCoupon: async function(coupon){
		if(this.getCookie('discount_code') === coupon) return;
		let response = {status: null};
		
		let request = await $.get(location.origin+"/discount/"+coupon, function(data) {
		  response.status = true;
		}).fail(() => {
			response.status = false;
		});
		
		this.setCookie('discount_code', coupon, 7);
			
		if(response.status){
			location.reload();
		}
	},
	
	init: function(){
		const fieldCoupomCart = document.querySelector("#CartDrawer #addCoupoun");
		
		if(fieldCoupomCart != null){
			if(this.getCookie('discount_code')){
				fieldCoupomCart.querySelector("form input").value = this.getCookie('discount_code');
			}
			
			fieldCoupomCart.querySelector("form").addEventListener("submit", (e) => {
				e.preventDefault();
				
				const coupon = fieldCoupomCart.querySelector("form input").value;
								
				if(coupon != ""){
					this.applyCoupon(coupon);
				}
			})
			
		}
	}
}

$(document).ready(function () {
  manageCoupon.init();
});

class Theme{
	init(){
		const closeBtn = document.querySelector('#close-minicart');
		
		if(closeBtn){
			closeBtn.addEventListener("click", (e) => {
				e.preventDefault();
				document.querySelector('.window-overlay').click();
			});
		}
	}
}


const theme = new Theme();
theme.init();



window.addEventListener("load", () => {
  (function() {
      'use strict';
      var oldXHR, stateChangeHandler, prop;
    
      oldXHR = window.XMLHttpRequest;
    
      stateChangeHandler = function (evt) {
        switch (this.readyState) {
          case oldXHR.OPENED:
            //console.log('Request was made', this, evt);
            break;
          case oldXHR.DONE:
              //console.log('Request was finished', this);
              if(this.responseURL.indexOf('/cart/shipping_rates.json?') != -1)
            	theme.init();
            break;
        }
      };
    
      function newXHR() {
        var xhr = new oldXHR();
        xhr.addEventListener('readystatechange', stateChangeHandler);
        return xhr;
      }
    
      // Copy original states and toString
      for (prop in oldXHR)
        newXHR[prop] = oldXHR[prop];
      
      window.XMLHttpRequest = newXHR;
    })();
});


window.addEventListener('load', function() {
    document.querySelectorAll('.header-menu .header-menu__list.header-menu__list--main .header-menu__item-text').forEach((item) => {
        if(item.textContent.trim().toLowerCase() === 'sale') {
            item.classList.add('menu-sale');
        }
    });
});

const ProductPage = {
    init: function() {
        this.checkIfMobile();
    },

    checkIfMobile: function() {
        if (window.innerWidth < 1199) {
            this.moveBreadcrumb();
            this.moveProductFormMobile();
        }
    },

    moveBreadcrumb: function() {
        const templateProductPage = document.querySelector('.template-product');
        if (templateProductPage !== null) {
            const breadcrumb = document.querySelector('nav.breadcrumb');
            const productForm = document.querySelector('form.product-form');

            if (breadcrumb && productForm) {
                productForm.insertAdjacentElement('afterbegin', breadcrumb);
            }
        }
    },

    moveProductFormMobile: function() {
        const productFormMobile = document.querySelector('.js-product-form-mobile');
        const breadcrumb = document.querySelector('nav.breadcrumb');

        if (productFormMobile && breadcrumb) {
            breadcrumb.insertAdjacentElement('afterend', productFormMobile);
        }
    }
};

window.addEventListener('load', function() {
    ProductPage.init();
    recomendedCustomSwatches()
});


document.querySelector('.header__icon--search-mobile').addEventListener('click', function() {
    const lupaIcon = document.querySelector('.header__icon--lupa');
    const closeIcon = document.querySelector('.header__icon--close');
    const searchMobile = document.querySelector('.search__mobile');

    // Toggle the display of icons
    if (lupaIcon.style.display !== 'none') {
        lupaIcon.style.display = 'none';
        closeIcon.style.display = 'block';
    } else {
        lupaIcon.style.display = 'block';
        closeIcon.style.display = 'none';
    }

    // Toggle the 'show' class on .search__mobile
    searchMobile.classList.toggle('show');
});

function productCardCustomSwatches(){
	let swatchesWrapper = document.querySelectorAll('.product-card__swatches-wrapper');

	
	swatchesWrapper.forEach((item) => {
		let swatchesParent = item
		let hex = item.querySelectorAll('.product-card_custom-hex span');
		hex.forEach((item)=>{
			let h = item.dataset.hex;
			let colorName = item.dataset.value.split('/');
			
			let dataSwatch = swatchesParent.querySelectorAll('[data-swatch]');
			dataSwatch.forEach((sku) => {
				let newName = colorName[0].replace(/(\r\n|\n|\r)/gm, "");
				if(newName.includes(sku.dataset.swatch) && h){
					sku.style=`--swatch-color:${h}`
				}
			})
		})
	})
	
}


function recomendedCustomSwatches(){
	// Selecionar o elemento que precisa ser observado
	const targetSelector = '.product-recommendations.is-loading';
	if(document.querySelector(targetSelector)){
		function elementoCarregado() {
		    productCardCustomSwatches();
		}
		
		const intervalId = setInterval(() => {
		    const elemento = document.querySelector(targetSelector);
		    if (!elemento) {
		        elementoCarregado();
		        clearInterval(intervalId); // Parar de verificar após encontrar o elemento
		    }
		}, 1000); // Verificar a cada 1000ms (1 segundo)
	} else {
		productCardCustomSwatches()
	}
}


function addShowClassOnVideoClick() {
    const videoElement = document.querySelector('.promotion-content__video');
    const overlayElement = document.querySelector('.promotion-content__overlay');
    const body = document.body;

    if (videoElement && overlayElement) {
        // Adicionar a classe "show" ao clicar no vídeo
        videoElement.addEventListener('click', () => {
            overlayElement.classList.add('show');
            body.style.overflow = 'hidden'; // Desativa o scroll no body
        });

        // Remover a classe "show" ao clicar no overlay
        overlayElement.addEventListener('click', () => {
            overlayElement.classList.remove('show');
            body.style.overflow = ''; // Restaura o scroll no body
        });
    }
}

// Chamada da função
addShowClassOnVideoClick();



const forceHideElement = setInterval(() => {
    const modalMarkElement = document.querySelector("#appView .powrModal .powrMark");
    if (modalMarkElement) {
        modalMarkElement.style.display = "none"; // Oculta o elemento
        modalMarkElement.style.visibility = "hidden"; // Garante que não apareça
        modalMarkElement.style.opacity = "0"; // Torna invisível mesmo se visibilidade for alterada
        clearInterval(forceHideElement); // Para o intervalo
    }
}, 1000);

// Altera o text padrão do botão de pagamento na página do produto de "Compre já" para "Comprar"
function changeButtonText() {
    const paymentButton = document.querySelector('.shopify-payment-button__button');
    if (paymentButton) {
        paymentButton.textContent = "Comprar";
    }
}

changeButtonText();








